import graphql from "../../graphql";

export default {
  namespaced: true,
  state: {
    searchResults: [],
  },
  getters: {
    getSearchResults: state => state.searchResults,
  },
  actions: {
    fetchSearchResults: ({ commit, rootState }, { keywords, city = "", vendor = {} }) => {
      if (keywords?.length) {
        graphql
          .query({
            query: productsQuery(rootState.global.currentLocale),
            variables: { keywords, city, vendor: vendor.hashid },
          })
          .then(response => commit("setSearchResults", response.data.productSearch.products));
      } else {
        commit("setSearchResults", []);
      }
    },
    clearSearchResults: ({ commit }) => {
      commit("setSearchResults", []);
    },
  },
  mutations: {
    setSearchResults: (state, data) => {
      state.searchResults = data;
    },
  },
};

const productsQuery = locale => `
  query ProductSearch($keywords: String!, $city: ID!, $vendor: ID){
    productSearch(keywords: $keywords, cityZone: $city, vendor: $vendor) {
      products {
        name {
          ${locale}
          de
        }
        permalink
        images {
          url(width: 30, height: 30, operation: crop)
        }
      }
    }
  }
`;
